import env from '../helpers/env';
import hasOpenTokSupportHelpers from '../helpers/hasOpenTokSupport';

const hasOpenTokSupport = hasOpenTokSupportHelpers.once;

export default () => hasOpenTokSupport() &&
  (env.isChromiumEdge || ['Chrome', 'Samsung', 'Safari', 'Firefox', 'Opera'].includes(env.name));
